// Maker Embed Script
(function() {
    // Geo placeholders replaced by the CF Worker proxy before the script reaches the browser.
    // Falls back to empty strings when served directly from CDN (e.g. local dev).
    window.__mkrLocale = window.__mkrLocale || { country: '__CF_COUNTRY__', city: '__CF_CITY__', region: '__CF_REGION__', regionCode: '__CF_REGION_CODE__' };

    function decodeMockGeoParam(search) {
        const param = new URLSearchParams(search).get('mkr_geo');
        if (!param) return null;
        try {
            // A raw "+" in a hand-built base64 query value decodes to a space under
            // form-urlencoded rules; undo that before atob (space is never valid base64).
            return JSON.parse(atob(param.replace(/ /g, '+')));
        } catch (e) {
            return null;
        }
    }

    function applyMockGeo() {
        const mock = window.__mkrGeoMockOverride || decodeMockGeoParam(window.location.search);
        if (!mock) return;
        window.__mkrLocale = {
            country: mock.country || window.__mkrLocale.country,
            city: mock.city || window.__mkrLocale.city,
            region: mock.region || window.__mkrLocale.region,
            regionCode: mock.regionCode || window.__mkrLocale.regionCode,
        };
    }
    applyMockGeo();

    

    // document.currentScript is only valid during this initial synchronous
    // execution; capture everything derived from it before any deferral
    // (createContainer may wait for DOMContentLoaded).
    const scriptElement = document.currentScript;
    const baseUrl = scriptElement && scriptElement.src ? scriptElement.src.split('/embed.js')[0] : '';
    const loadTs = scriptElement && scriptElement.getAttribute('data-mkr-load-ts');

    function buildContainerEl() {
        const container = document.createElement('div');
        container.id = 'cmhd1gtfc0001vb0yeeofdn9z-root';
        container.className = 'cmhd1gtfc0001vb0yeeofdn9z-app makerai-app';
        return container;
    }

    function tryMountContainer(scriptEl) {
        const existing = document.getElementById('cmhd1gtfc0001vb0yeeofdn9z-root');
        if (existing) {
            // The documented copy-paste snippet ships this div bare (no
            // class) — every rule in main.css is scoped behind
            // .cmhd1gtfc0001vb0yeeofdn9z-app, so without this the app renders unstyled.
            existing.classList.add('cmhd1gtfc0001vb0yeeofdn9z-app', 'makerai-app');
            return existing;
        }
        const targetId = scriptEl && scriptEl.getAttribute('data-target-id');
        if (targetId) {
            const target = document.getElementById(targetId);
            if (target) {
                const container = buildContainerEl();
                target.appendChild(container);
                return container;
            }
        }
        return null;
    }

    function mountFallbackContainer(scriptEl) {
        const targetId = scriptEl && scriptEl.getAttribute('data-target-id');
        if (targetId) {
            console.warn('[maker-embed] data-target-id "' + targetId + '" not found in DOM, falling back to default placement.');
        }
        const container = buildContainerEl();
        if (scriptEl && scriptEl.parentNode && scriptEl.parentNode !== document.head) {
            scriptEl.parentNode.insertBefore(container, scriptEl);
        } else {
            // Org-embed default rules inject this script into <head> on
            // purpose (data-mkr-org-project set) — the root-div advice only
            // applies to hand-pasted snippets.
            if (!scriptEl || !scriptEl.hasAttribute('data-mkr-org-project')) {
                console.warn('[maker-embed] No #cmhd1gtfc0001vb0yeeofdn9z-root element found. Add <div id="cmhd1gtfc0001vb0yeeofdn9z-root"></div> where the app should render; appending to <body> instead.');
            }
            document.body.appendChild(container);
        }
        return container;
    }

    function createContainer(scriptEl) {
        return new Promise(function(resolve) {
            const mounted = tryMountContainer(scriptEl);
            if (mounted) { resolve(mounted); return; }
            if (document.readyState === 'loading') {
                // documentElement, not body: body is null while the parser is
                // still inside <head>.
                let settled = false;
                const observer = new MutationObserver(function() {
                    if (settled) return;
                    const el = tryMountContainer(scriptEl);
                    if (el) { settled = true; observer.disconnect(); resolve(el); }
                });
                observer.observe(document.documentElement, { childList: true, subtree: true });
                document.addEventListener('DOMContentLoaded', function() {
                    if (settled) return;
                    settled = true;
                    observer.disconnect();
                    const retry = tryMountContainer(scriptEl);
                    resolve(retry || mountFallbackContainer(scriptEl));
                }, { once: true });
                return;
            }
            resolve(mountFallbackContainer(scriptEl));
        });
    }


    function addMadeWithMakerLink(container) {
     return new Promise((resolve, reject) => {
        const link = document.createElement('a');
        link.href = 'https://ai.maker.co';
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.position = 'sticky';
        link.style.bottom = '8px';
        link.style.right = '8px';
        link.style.left = '8px';
        link.style.textDecoration = 'none';
        link.style.zIndex = '9999';
        link.style.display = 'block';
        link.style.height = '24px';
        link.style.width = 'fit-content';
        link.style.lineHeight = '24px';
        link.style.padding = '0 8px';
        link.style.borderRadius = '6px';
        link.style.backgroundColor = 'rgba(0, 0, 0, 0.60)';
        link.style.backdropFilter = 'blur(2px)';
        link.style.color = '#FFF';
        link.style.fontFamily = 'sans-serif';
        link.style.fontSize = '12px';
        link.style.fontWeight = '500';
        link.textContent = 'Made with maker';
        container.appendChild(link);
        resolve();
      });
    }


    function loadCSS(href) {
        return new Promise(function(resolve) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.setAttribute('fetchpriority', 'high');
            link.href = href;
            link.onload = resolve;
            link.onerror = resolve;
            document.head.appendChild(link);
        });
    }

    function loadScript(src, external, is_async, attrs) {
        return new Promise(function(resolve, reject) {
            const script = document.createElement('script');
            script.type = external ? 'text/javascript' : 'module';
            script.setAttribute('fetchpriority', 'high');
            Object.entries(attrs || {}).forEach(function(entry) {
                script.setAttribute(entry[0], entry[1]);
            });
            script.src = src;
            if (is_async) script.async = true;
            script.onload = resolve;
            script.onerror = reject;
            (external ? document.head : document.body).appendChild(script);
        });
    }

    function loadInlineScripts(type, scriptContent, tagName) {
        return new Promise(function(resolve, reject) {
            try {
                const script = document.createElement(tagName);
                if (tagName == 'script') script.type = type;
                script.textContent = scriptContent;
                document.body.appendChild(script);
                resolve();
            } catch (e) {
                reject(e);
            }
        });
    }


    function trackScrollDepth(container) {
        // Direct script-embed only: an SPA host re-injects the whole embed.js IIFE on
        // client-side navigation (see the loadTs "?_r=" comment in createInitSnippet)
        // while createContainer reuses the same #<projectId>-root div across re-injections.
        // Without this guard every re-injection would attach another scroll/resize
        // listener to the same still-live container, firing duplicate captures per
        // checkpoint on the next real scroll.
        if (container.__mkrScrollDepthTracked) return;
        container.__mkrScrollDepthTracked = true;

        // trackScrollDepth() runs synchronously inside embed.js's init(), before any
        // await — an uncaught throw here propagates straight into init()'s own catch,
        // which abandons the rest of init() including the DOMContentLoaded dispatch
        // main.jsx waits for to mount the widget at all. Nothing below may ever escape
        // this function, however it fails (cross-origin window.parent access, a missing
        // requestAnimationFrame in some unusual embedding context, etc.) — nothing here
        // is worth a blank page over.
        try {
            var CHECKPOINTS = [25, 50, 75, 100];
            var reached = {};
            var frameEl = null;
            try {
                frameEl = window.frameElement;
            } catch (e) {}
            var scrollTarget = frameEl ? window.parent : window;
            var measureEl = frameEl || container;
            var ticking = false;
            var resizeObserver = null;

            // The org-embed slot-injection flow (src/templates/org-embed/embed.ts) removes
            // the old #<projectId>-root div from the DOM on every SPA route change and
            // reinjects a fresh embed.js for the new route, which builds a brand-new
            // container. scrollTarget.addEventListener is attached to window, not the
            // container, so without this the orphaned container's listeners would keep
            // firing (harmlessly, but forever) for the rest of the page's lifetime. Detach
            // as soon as any trigger notices the container it was tracking is gone.
            function teardown() {
                try { scrollTarget.removeEventListener('scroll', onScroll); } catch (e) {}
                try { scrollTarget.removeEventListener('resize', onScroll); } catch (e) {}
                try { if (resizeObserver) resizeObserver.disconnect(); } catch (e) {}
            }

            function currentPercentage() {
                var rect = measureEl.getBoundingClientRect();
                if (!rect.height) return 0;
                var viewportHeight = scrollTarget.innerHeight || 0;
                var visible = viewportHeight - rect.top;
                if (visible <= 0) return 0;
                if (visible >= rect.height) return 100;
                return (visible / rect.height) * 100;
            }

            function onScroll() {
                if (!container.isConnected) {
                    teardown();
                    return;
                }
                if (ticking) return;
                ticking = true;
                try {
                    var raf = (scrollTarget && scrollTarget.requestAnimationFrame) || window.requestAnimationFrame;
                    if (!raf) {
                        ticking = false;
                        return;
                    }
                    raf(function() {
                        ticking = false;
                        try {
                            var pct = currentPercentage();
                            for (var i = 0; i < CHECKPOINTS.length; i++) {
                                var checkpoint = CHECKPOINTS[i];
                                if (!reached[checkpoint] && pct >= checkpoint) {
                                    reached[checkpoint] = true;
                                    if (window.posthog && window.posthog.capture) {
                                        window.posthog.capture('scroll_depth_reached', { scroll_depth: checkpoint });
                                    }
                                }
                            }
                        } catch (e) {}
                    });
                } catch (e) {
                    ticking = false;
                }
            }

            scrollTarget.addEventListener('scroll', onScroll, { passive: true });
            scrollTarget.addEventListener('resize', onScroll, { passive: true });

            // trackScrollDepth() runs the instant the (still-empty) root div is mounted,
            // well before main.js has loaded and rendered content into it — a scroll/resize
            // listener alone would miss any checkpoint that's already satisfied once content
            // renders, if the visitor never scrolls or resizes the window again afterward
            // (the common case for small above-the-fold widgets). Re-check on every layout
            // change to the container itself, not just the window.
            if (typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(onScroll);
                resizeObserver.observe(container);
            }

            scrollTarget.addEventListener('pagehide', teardown, { once: true });

            onScroll();
        } catch (e) {}
    }


    async function init() {
        try {
            // CSS only touches <head>; start it while the container mount may
            // still be waiting for the target to be parsed.
            const cssReady = loadCSS(baseUrl + '/assets/main.css');

            // loadTs makes the ES module registry treat each SPA re-injection
            // as a distinct URL so main.js re-executes (A -> B -> A fix).
            const mainSrc = baseUrl + '/assets/main.js' + (loadTs ? '?_r=' + loadTs : '');

            // The module <script> can only be appended once the body exists,
            // but its download can start now — same-document preload match,
            // so the later loadScript reuses the response instead of
            // serializing behind the container mount.
            const warmMain = document.createElement('link');
            warmMain.rel = 'modulepreload';
            warmMain.href = mainSrc;
            document.head.appendChild(warmMain);

            // Everything below appends to <body>; createContainer resolving
            // guarantees the body exists.
            const container = await createContainer(scriptElement);

            const posthogReady = loadInlineScripts("text/javascript", "\n(function() {\n  // PostHog SDK stub — init is deferred until consent is confirmed.\n  !function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(\".\");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement(\"script\")).type=\"text/javascript\",p.crossOrigin=\"anonymous\",p.async=!0,p.src=s.api_host.replace(\".i.posthog.com\",\"-assets.i.posthog.com\")+\"/static/array.js\",(r=t.getElementsByTagName(\"script\")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a=\"posthog\",u.people=u.people||[],u.toString=function(t){var e=\"posthog\";return\"posthog\"!==a&&(e+=\".\"+a),t||(e+=\" (stub)\"),e},u.people.toString=function(){return u.toString(1)+\".people (stub)\"},o=\"Ir Sr init jr $r Ci qr Hr Dr capture calculateEventProperties Wr register register_once register_for_session unregister unregister_for_session Qr getFeatureFlag getFeatureFlagPayload getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync tn identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty Jr Yr createPersonProfile setInternalOrTestUser Kr Pr nn opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing zr debug ki Xr getPageViewId captureTraceFeedback captureTraceMetric Mr\".split(\" \"),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);\n\n  var _mkrPhToken = 'phc_qbDTSuJCBxyX8CACLOEhPNZBvJVcELuLXGG6J2ibUmK';\n  var _mkrPhConfig = {\n    api_host: 'https://athena.maker.co',\n    ui_host: 'https://us.posthog.com',\n    defaults: '2026-01-30',\n    person_profiles: 'identified_only',\n    name: 'ph_devi_cmhd1gtfc0001vb0yeeofdn9z',\n    autocapture: { css_selector_allowlist: ['[data-tracking-id]'] },\n    disable_surveys: true,\n    capture_dead_clicks: false,\n    loaded: function(posthog) {\n      posthog.register({\n        mkr_product: 'devi',\n        mkr_project_id: 'cmhd1gtfc0001vb0yeeofdn9z',\n        mkr_org_id: 'user_33tbl7B6e1bXN6KW4wjrevvqrth',\n        mkr_organization_name: 'unknown',\n        mkr_version: 1787731422996,\n        mkr_host_domain: window.__mkr_host_domain || window.location.hostname,\n        mkr_host_url: window.__mkr_host_url || window.location.href\n      });\n    },\n  };\n\n  var _mkrPhInited = false;\n  var syncPostHogToConsent = function(allowed) {\n    if (!allowed) {\n      if (_mkrPhInited) posthog.opt_out_capturing();\n      return;\n    }\n    if (_mkrPhInited) {\n      posthog.opt_in_capturing();\n    } else {\n      _mkrPhInited = true;\n      posthog.init(_mkrPhToken, _mkrPhConfig);\n    }\n  };\n\n  // Only an explicit analytics === 'no' from the Shopify CMP denies.\n  var readShopifyConsent = function() {\n    try {\n      var c = window.Shopify.customerPrivacy.currentVisitorConsent();\n      return c.analytics !== 'no';\n    } catch(e) { return true; }\n  };\n  var isConsentResolved = function() {\n    try {\n      var c = window.Shopify.customerPrivacy.currentVisitorConsent();\n      return c.analytics === 'yes' || c.analytics === 'no';\n    } catch(e) { return false; }\n  };\n\n  // Poll Shopify CMP every 100 ms; fail-open after 3 s (handles US stores with no banner).\n  var startShopifyConsentPolling = function() {\n    var start = Date.now(), resolved = false;\n    var interval = setInterval(function() {\n      if (resolved) return;\n      if (!isConsentResolved() && Date.now() - start < 3000) return;\n      clearInterval(interval);\n      resolved = true;\n      syncPostHogToConsent(readShopifyConsent());\n    }, 100);\n    document.addEventListener('visitorConsentCollected', function() {\n      if (!resolved) { clearInterval(interval); resolved = true; }\n      syncPostHogToConsent(readShopifyConsent());\n    });\n  };\n\n  if (window.parent !== window) {\n    // Iframe embed branch — consent signals forwarded by the parent loader via window vars\n    // and postMessage. window.__mkr_shopify_cmp / __mkr_gpc / __mkr_accept_cookies are\n    // injected into the srcdoc by iframe.ts before embed.js loads.\n    if (window.__mkr_gpc) {\n      // GPC forwarded from parent — deny, don't init.\n    } else if (!window.__mkr_accept_cookies) {\n      // Explicit acceptCookies=false forwarded from parent — deny.\n    } else if (!window.__mkr_shopify_cmp) {\n      // No Shopify CMP on the parent page — allow.\n      syncPostHogToConsent(true);\n    } else {\n      // Shopify CMP detected on parent — default-deny, wait for consent postMessage.\n      // Attach listener before posting ready so no message is missed.\n      var _mkrIframeConsentReceived = false;\n      var _mkrIframeFailOpen = setTimeout(function() {\n        if (!_mkrIframeConsentReceived) {\n          _mkrIframeConsentReceived = true;\n          syncPostHogToConsent(true);\n        }\n      }, 3000);\n      window.addEventListener('message', function(e) {\n        if (!e.data || e.data.type !== 'mkr_tracking_consent') return;\n        if (!_mkrIframeConsentReceived) {\n          clearTimeout(_mkrIframeFailOpen);\n          _mkrIframeConsentReceived = true;\n        }\n        syncPostHogToConsent(e.data.allowed);\n      });\n      // Tell the parent this listener is ready so it can flush any buffered consent.\n      window.parent.postMessage({ type: 'mkr_iframe_consent_ready' }, '*');\n    }\n  } else {\n    // Top-frame branch — simple and org embeds running directly on the customer's page.\n    if (navigator.globalPrivacyControl === true) {\n      // GPC: first-class deny signal, no init.\n    } else if (window.acceptCookies === false) {\n      // Explicit acceptCookies=false deny — checked before Shopify CMP so it always wins.\n    } else if (!window.Shopify || typeof window.Shopify !== 'object') {\n      // Non-Shopify site (or null window.Shopify): no explicit deny → allow.\n      syncPostHogToConsent(true);\n    } else {\n      // Shopify store: auto-detect CMP, poll for consent, subscribe to runtime changes.\n      startShopifyConsentPolling();\n    }\n  }\n})();\n  ", "script");
            // Scroll-depth tracking is analytics-only and must never be able to take the
            // real render path down with it — a throw here, uncaught, would skip the
            // mainReady assignment below and silently abort the whole widget.
            try { trackScrollDepth(container); } catch (e) {}

            const mainReady = loadScript(mainSrc, false, true);

            await Promise.all([cssReady, mainReady]);
            
            await posthogReady;
            
            
            // Trigger DOMContentLoaded so main.jsx's handler finds the container.
            document.dispatchEvent(new Event('DOMContentLoaded'));
        } catch (error) {
            console.error('Failed to load maker widget:', error);
        }
    }

    init();

})();